import {get} from "../utils";

export default host => (clients = [], brands = []) =>
  get(`${host}/users/downloadLink?${clients.length > 0 ? `&clients=${clients.map(client => client.value)}` : '' }${brands.length > 0 ? `&brands=${brands.map(brand => brand.value)}` : '' }`)
    .then(response => response.text())

